const trucateFilename = (filename: string = '', maxLength: number = 10) => {
    if (filename.length > maxLength) {
        return `${filename.slice(0, 5)}...${filename.slice(-7)}`;
    }
    return filename;
};

export default trucateFilename;
